import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { themes } from "services/constants";
import * as Mui from "@mui/material";

const fallbackAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export const CustomAutoCompleteWithLogo = ({
  dataList,
  selectedValue,
  Icons,
  updateDataFunction,
  rules,
  placeHolder,
  label,
  errorMessage,
  textBoxError,
  disableAction,
  showAvathar,
  setShowAutoCompleteAvathar,
}) => {
  return (
    <Autocomplete
      disablePortal
      id="combo-box"
      size="small"
      value={selectedValue}
      options={dataList}
      InputLabelProps={{ shrink: true }}
      sx={{ width: "100%" }}
      ListboxProps={{ style: { maxHeight: "150px" } }}
      filterOptions={(options, state) =>
        options.filter((option) =>
          option?.label?.toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
      isOptionEqualToValue={(option, value) =>
        (option?.id ?? option?.user_id) === (value?.id ?? value?.user_id)
      }
      renderOption={(props, option) => (
        <li
          {...props}
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          <Mui.Avatar
            src={option.image || fallbackAvatar}
            // alt={option.label}
            alt={option.label?.charAt(0).toUpperCase()}
            style={{
              width: 25,
              height: 25,
              borderRadius: "50%",
              objectFit: "cover",
              backgroundColor: "#f0f0f0",
            }}
          />

          {option.label}
        </li>
      )}
      // isOptionEqualToValue={(option, value) => option?.label === value?.label}

      onChange={(event, value) => updateDataFunction(event, value)}
      disabled={disableAction}
      renderInput={(params) => (
        <TextField
          onBlur={() => {
            setShowAutoCompleteAvathar(false);
          }}
          {...params}
          sx={{ background: themes.whiteColor, borderRadius: "10px" }}
          label={label}
          placeholder={placeHolder}
          size="small"
          value={selectedValue}
          rules={rules}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {selectedValue && !showAvathar && (
                  <Mui.Avatar
                    src={selectedValue.image || fallbackAvatar}
                    // alt={selectedValue.label}
                    alt={selectedValue.label?.charAt(0).toUpperCase()}
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: "50%",
                      marginRight: 3,
                      objectFit: "cover",
                    }}
                  />
                )}
                {Icons && (
                  <Icons style={{ marginRight: "8px", color: "#a6a6a6" }} />
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
          error={textBoxError}
          helperText={errorMessage}
          fullWidth
          disabled={disableAction}
        />
      )}
    />
  );
};
